import { useContext } from 'react';

import { DeviceIntelligenceContext, type DeviceIntelligenceContextType } from '../client/DeviceIntelligenceProvider';

export function useDeviceIntelligence(): DeviceIntelligenceContextType {
	const context = useContext(DeviceIntelligenceContext);

	if (!context) {
		throw new Error('"useDeviceIntelligence" must be used within a Provider');
	}

	return context;
}
